import PocketBase from 'pocketbase'

// export const pb = new PocketBase('http://192.168.1.183:8090')
// export const pb = new PocketBase('http://127.0.0.1:8090')

export const pb = new PocketBase(import.meta.env.VITE_POCKETBASE_URL)
pb.autoCancellation(false)